// extracted by mini-css-extract-plugin
export var partnerListBackgroundColor = "index-module--partnerListBackgroundColor--TKHE5";
export var partnerListCard = "index-module--partnerListCard--Bv5Fw";
export var partnerListCardDetails = "index-module--partnerListCardDetails--PyWrW";
export var partnerListCardItem = "index-module--partnerListCardItem--kHskA";
export var partnerListCardLogo = "index-module--partnerListCardLogo--kLjDw";
export var partnerListCardLogoWrapper = "index-module--partnerListCardLogoWrapper--mjmyF";
export var partnerListContainer = "index-module--partnerListContainer--FiPje";
export var partnerListContent = "index-module--partnerListContent--M2EKM";
export var partnerListFilterItem = "index-module--partnerListFilterItem--W-s4b";
export var partnerListFilters = "index-module--partnerListFilters--+QEyk";
export var partnerListNoResult = "index-module--partnerListNoResult--2fEX4";
export var partnerListNoResultWrapper = "index-module--partnerListNoResultWrapper--+bYZC";